<template>
  <div class="player flex align-center justify-center">
    <div class="content" v-if="propsData">
      <img
        class="close_img cs"
        src="../../assets/images/personal/close2.png"
        @click.stop="didClcik_close"
      />
      <div
        class="title flex align-center justify-start"
        v-show="propsData.title"
      >
        <span class="leftbox"></span>
        <span class="text">{{ propsData.title }}</span>
      </div>
      <video
        ref="myVideoPlay"
        :poster="propsData.showImagesRealPath[0]"
        :src="propsData.url"
        :controls="true"
        oncontextmenu="return false"
        controlslist="nodownload noremoteplayback"
        disablePictureInPicture
        class="video-box"
        autoplay="autoplay"
      >
        <source :src="propsData.url" type="video/mp4" />
        <source :src="propsData.url" type="video/ogg" />
        <source :src="propsData.url" type="video/webm" />
      </video>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoPlayer",
  props: {
    propsData: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    didClcik_close() {
      this.$emit("changeSelectVideo");
    },
  },
};
</script>

<style lang="scss" scoped>
.close_img {
  width: 50px;
  height: 50px;
  margin-left: 90%;
  padding: 5px;
  float: right;
}
@media screen and (max-width: 992px) {
  .player {
    position: fixed;
    z-index: 10000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: #8c9498;
    .content {
      height: auto;
      width: calc(100% - 70px);
      .close_img {
        width: 50px;
        height: 50px;
        margin-left: 90%;
        padding: 5px;
        float: right;
      }
      .title {
        width: 100%;
        height: 41px;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        .leftbox {
          width: 9px;
          height: 39px;
          background: #b4251e;
          border-radius: 0 0 0 0;
          opacity: 1;
        }
        .text {
          width: 100%;
          font-size: 34px;
          font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑";
          font-weight: 600;
          color: #ffffff;
          line-height: 40px;
          margin-left: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .video-box {
        width: 100%;
        height: auto;
        margin-top: 22px;
      }
    }
  }
}
@media screen and (min-width: 992px) {
  .player {
    position: fixed;
    z-index: 10000;
    top: -50px;
    left: 0;
    width: 100%;
    height: calc(100vh + 50px);
    background: rgba(0, 0, 0, 0.5);
    .content {
      width: calc(100% - 720px);

      .title {
        width: 100%;
        height: 36px;

        color: #ffffff;
        line-height: 35px;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        .leftbox {
          width: 9px;
          height: 39px;
          background: #b4251e;
          border-radius: 0 0 0 0;
          opacity: 1;
        }
        .text {
          font-size: 30px;
          font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑";
          font-weight: 600;
          height: 36px;
          color: #ffffff;
          line-height: 40px;
          margin-left: 31px;
        }
      }
      .video-box {
        width: 100%;
        height: auto;
        margin-top: 22px;
      }
      .video-box {
        outline: 0 !important;
      }
    }
  }
}
</style>
